<template>
  <div>
    <layout-headers
      title="usersPageTitle"
      text="usersPageSubtitle"
      :redirectButtons="redirectButtons"
    />

    <filters
      :tableData="tableData"
      v-model="search"
      @filtered-list="getFilteredList"
      :fields="['email', 'name']"
    />
    <br>
    <el-card>
      <el-table :data="filteredData" :empty-text="emptyText">
        <el-table-column sortable prop="name" :label="$t('usersName')"/>
        <el-table-column sortable prop="email" :label="$t('usersEmail')"/>
        <el-table-column prop="role" :label="$t('usersRole')">
          <template slot-scope="scope">
            <div v-for="(value, key) in scope.row.roles" v-bind:key="key">{{value.name}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="actions" fixed="right" width="120" :label="$t('tableActions')">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" placement="left-start">
              <div slot="content">{{ $t('tooltipInfo') }}</div>
              <el-button
                type="info"
                icon="el-icon-view"
                class="table-button"
                @click="$router.push({name: 'SingleUser', params: {id: scope.row.id}})"
              ></el-button>
            </el-tooltip>
            <el-button
              type="primary"
              icon="el-icon-edit"
              class="table-button"
              @click="edit('UserEdit', scope.row, 'user')"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              class="table-button"
              @click="showModal(scope.row.id, scope.$index, 'user')"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <modal :config="modalConfig" @closeModal="deleteUser"/>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/api";
import Filters from "../Filters/Filter";
import LayoutHeaders from "../LayoutPart/LayoutHeaders";
import { success } from "../Notification/notification";
import { getFilteredList, edit } from "@/helpers/helpers";
import Modal from "../Modal/Modal";
import { showModal, closeModal } from "../Modal/ModalHelpers";

export default {
  name: "users",
  components: {
    LayoutHeaders,
    Filters,
    Modal
  },
  computed: {
    ...mapGetters({
      users: "getUsers",
      authToken: "getAuthToken"
    })
  },
  created() {
    this.initList();
  },
  data() {
    return {
      emptyText: "Loading...",
      tableData: [],
      modalConfig: { show: false },
      filteredData: undefined,
      search: "",
      redirectButtons: [
        {
          path: "UserAdd",
          param: {},
          text: "usersCreate"
        }
      ]
    };
  },
  methods: {
    edit,
    getFilteredList,
    success,
    showModal,
    closeModal,
    initList() {
      this.$store.dispatch("fetchUsers").then(() => {
        this.emptyText = "No results";
        this.filteredData = this.users;
        this.tableData = this.users;
      });
    },
    deleteUser() {
      const { id } = this;
      this.modalConfig.show = false;

      api
        .deleteUsers(id)
        .then(() => {
          this.$delete(this.users, this.index);

          this.success("User", "deleted");
        })
        .catch(err => {});

      this.filteredData = this.tableData;
    }
  }
};
</script>

<style scoped>
.table-button {
  width: 30px !important;
  height: 30px !important;
  padding: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  color: darkgrey;
  font-size: 20px;
  font-weight: 800;
  border: none;
}

.table-button:hover {
  color: #409eff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Users.vue